"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTenantSchema = exports.createTenantSchema = void 0;
const zod_1 = require("zod");
exports.createTenantSchema = zod_1.z.object({
    code: zod_1.z
        .string()
        .min(2)
        .max(20)
        .regex(/^[A-Z0-9]+$/, 'Tenant code must be uppercase alphanumeric'),
    name: zod_1.z.string().min(1).max(255),
});
exports.updateTenantSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(255).optional(),
});
//# sourceMappingURL=tenant.schema.js.map